import {ExpressionPathPart} from '@packages/systems/wfdl';

export const DEFAULT_LANGUAGE = 'javascript';
export const DEFAULT_THEME = 'dark';
export const DEFAULT_LINE_NUMBERS = false;

export const CODE_PATH: Array<ExpressionPathPart> = [
  {in: 'Record', at: 'code'},
];
export const LANGUAGE_PATH: Array<ExpressionPathPart> = [
  {in: 'Record', at: 'language'},
];
export const THEME_PATH: Array<ExpressionPathPart> = [
  {in: 'Record', at: 'theme'},
];
export const LINE_NUMBERS_PATH: Array<ExpressionPathPart> = [
  {in: 'Record', at: 'lineNumbers'},
];

export const SUPPORTED_LANGUAGES: {
  [key: string]: string;
} = {
  arduino: 'Arduino',
  bash: 'Bash',
  basic: 'Basic',
  bnf: 'BNF',
  c: 'C',
  clojure: 'Clojure',
  coffeescript: 'CoffeeScript',
  coq: 'Coq',
  cpp: 'C++',
  css: 'CSS',
  dart: 'Dart',
  diff: 'Diff',
  dockerfile: 'Docker',
  ebnf: 'EBNF',
  elixir: 'Elixir',
  elm: 'Elm',
  erlang: 'Erlang',
  gherkin: 'Gherkin',
  glsl: 'GLSL',
  go: 'Go',
  groovy: 'Groovy',
  haskell: 'Haskell',
  htmlbars: 'HTML',
  java: 'Java',
  javascript: 'JavaScript',
  json: 'JSON',
  julia: 'Julia',
  kotlin: 'Kotlin',
  latex: 'LaTeX',
  less: 'Less',
  lisp: 'Lisp',
  livescript: 'LiveScript',
  llvm: 'LLVM IR',
  lua: 'Lua',
  makefile: 'Makefile',
  markdown: 'Markdown',
  mathematica: 'Mathematica',
  matlab: 'MATLAB',
  nix: 'Nix',
  objectivec: 'Objective-C',
  ocaml: 'OCaml',
  perl: 'Perl',
  php: 'PHP',
  plaintext: 'Plain Text',
  powershell: 'PowerShell',
  prolog: 'Prolog',
  protobuf: 'Protobuf',
  python: 'Python',
  r: 'R',
  reasonml: 'Reason',
  ruby: 'Ruby',
  rust: 'Rust',
  sas: 'Sass',
  scala: 'Scala',
  scheme: 'Scheme',
  scss: 'SCSS',
  shell: 'Shell',
  sql: 'SQL',
  swift: 'Swift',
  typescript: 'TypeScript',
  vbnet: 'VB.NET',
  verilog: 'Verilog',
  vhdl: 'VHDL',
  xml: 'XML',
  yaml: 'YAML',
};

export const THEMES: {
  [key: string]: string;
} = {
  dark: 'Dark',
  light: 'Light',
};
